import React from 'react';
import { IonItem, IonList, IonSelect, IonSelectOption } from '@ionic/react';
import { OCCUPANT_TYPE } from '../../../utils/constants';

const StepSelect = ({ statementType, statementTypes, options, onChangeStatement }) => {
    return (
        <div>
            <IonList>
                <IonItem>
                    <IonSelect
                        label="Report Type"
                        labelPlacement="stacked"
                        value={statementType}
                        onIonChange={(e) => onChangeStatement(e.detail.value)}
                    >
                        {statementTypes.map((t) => (
                            <IonSelectOption key={t} value={t}>
                                {t === 'Tenant Statement' ? (options.userAccountType === OCCUPANT_TYPE ? 'Tenant Statement' : 'Member Statement') : t}
                            </IonSelectOption>
                        ))}
                    </IonSelect>
                </IonItem>
            </IonList>
        </div>
    );
};

export default StepSelect;


